import { render, staticRenderFns } from "./ShopImagesOtherField.vue?vue&type=template&id=52170da8&scoped=true"
import script from "./ShopImagesOtherField.vue?vue&type=script&lang=ts"
export * from "./ShopImagesOtherField.vue?vue&type=script&lang=ts"
import style0 from "./ShopImagesOtherField.vue?vue&type=style&index=0&id=52170da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52170da8",
  null
  
)

export default component.exports